<template>
    <div class="col-12 p-0">
      <!-- <p>{{ result }}</p> -->
      <p class="col-12 column-filter-heading m-0">{{ column.field }}</p>
      <div class="col-12" v-if="column.filter === 'numeric'">
        <div class="row">
          <div class="col-12 m-0">
            <label for="mininfilter" class="m-0">Min Value</label>
            <input
              id="none"
              name="none"
              class="d-none"
              type="number"
              style="opacity: 0"
            />
            <input
              id="mininfilter"
              name="minValue"
              class="form-control m-0"
              type="number"
              v-model="minValue"
            />
          </div>
          <div class="col-12 m-0">
            <label for="maxfilter" class="m-0">Max Value</label>
            <input
              id="maxfilter"
              name="maxValue"
              class="form-control m-0"
              type="number"
              v-model="maxValue"
            />
          </div>
          <div class="col-12 k-columnmenu-actions mt-2">
            <kbutton
              :theme-color="'primary'"
              type="button"
              @click="minMaxFilterHandler(column, filter)"
              >Filter</kbutton
            >
            <kbutton
              type="reset"
              @click="minMaxResetFilterHandler(column, filter)"
              >Reset</kbutton
            >
          </div>
        </div>
      </div>
      <div class="col-12 p-0" v-else>
        <GridColumnMenuCheckboxFilter
          :column="column"
          :filter="filter"
          :filterable="filterable"
          :unique-data="uniqueData"
          :search-box="true"
          :data-items="result"
          :expanded="true"
          @filterchange="filterChange"
          @expandchange="expandChange"
          @closemenu="closeMenu"
        />
      </div>
    </div>
  </template>
  <script>
  import {
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
    GridColumnMenuSort,
    GridColumnMenuItemGroup,
    GridColumnMenuItemContent,
    GridColumnMenuItem,
  } from "@progress/kendo-vue-grid";
  import { Button } from "@progress/kendo-vue-buttons";
  import { Filter } from "@progress/kendo-vue-data-tools";
  //   import { products } from './products';
  
  export default {
    props: {
      column: Object,
      sortable: [Boolean, Object],
      sort: {
        type: Array,
      },
      uniqueData: {
        type: Boolean,
        default: true,
      },
      filter: Object,
      filterable: Boolean,
      columns: Array,
      result: {},
    },
    data() {
      return {
        currentColumns: [],
        columnsExpanded: false,
        filterExpanded: false,
        minValue: "",
        maxValue: "",
      };
    },
    created() {
      this.$data.currentColumns = this.$props.columns;
    },
    mounted() {
      if (this.result.length) {
        this.minMaxValueFinder(this.$props.column, this.$props.filter);
      }
    },
    components: {
      //   GridColumnMenuSort: GridColumnMenuSort,
      // GridColumnMenuFilter: GridColumnMenuFilter,
      GridColumnMenuCheckboxFilter: GridColumnMenuCheckboxFilter,
      //   GridColumnMenuItemGroup: GridColumnMenuItemGroup,
      //   GridColumnMenuItemContent: GridColumnMenuItemContent,
      //   GridColumnMenuItem: GridColumnMenuItem,
      kbutton: Button,
    },
    computed: {
      oneVisibleColumn() {
        return this.currentColumns.filter((c) => !c.hidden).length === 1;
      },
    },
    emits: [
      "columnssubmit",
      "closemenu",
      "expandchange",
      "filterchange",
      "sortchange",
      "minMaxFilterHandler",
      "filterchangeCustomHandler",
    ],
    methods: {
      onReset(event) {
        event.preventDefault();
        const allColumns = this.$props.columns.map((col) => {
          return {
            ...col,
            hidden: false,
          };
        });
  
        this.currentColumns = allColumns;
        this.onSubmit();
      },
      onSubmit(event) {
        if (event) {
          event.preventDefault();
        }
        this.$emit("columnssubmit", this.currentColumns);
        this.$emit("closemenu");
      },
      onMenuItemClick() {
        const value = !this.columnsExpanded;
        this.columnsExpanded = value;
        this.filterExpanded = value ? false : this.filterExpanded;
      },
      onFilterExpandChange(value) {
        this.filterExpanded = value;
        this.columnsExpanded = value ? false : this.columnsExpanded;
      },
      expandChange() {
        this.$emit("expandchange");
      },
      closeMenu() {
        this.$emit("closemenu");
      },
      filterChange(newDescriptor, e) {
        // console.log("eeeeeeeeeeeee-filterChange>>>>>--->>>", newDescriptor, e);
        let filters = JSON.parse(JSON.stringify(newDescriptor));
        // console.log("filterChange CHILD", filters);
        this.$emit("filterchange", filters, e);
        this.$emit("filterchangeCustomHandler", filters, this.column);
        this.closeMenu();
      },
      sortChange(newDescriptor, e) {
        this.$emit("sortchange", newDescriptor, e);
      },
      minMaxFilterHandler() {
        let obj = {
          column: this.column,
          minValue: this.minValue,
          maxValue: this.maxValue,
        };
        this.$emit("minMaxFilterHandler", obj);
        this.closeMenu();
      },
      minMaxResetFilterHandler() {
        let obj = {
          column: this.column,
          minValue: "",
          maxValue: "",
        };
        this.minValue = "";
        this.maxValue = "";
        this.$emit("minMaxFilterHandler", obj);
      },
      minMaxValueFinder(column, filter) {
        this.columns.forEach((col) => {
          col.className = col.filter === "numeric" ? "text-right" : "";
          if (col.field === column.field) {
            if (col.minValue.length && col.maxValue.length) {
              this.minValue = col.minValue;
              this.maxValue = col.maxValue;
            }
          }
        });
      },
    },
  };
  </script>
  